export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const SET_CSC = "SET_CSC";
export const SET_SETTINGS = "SET_SETTINGS";
export const UPDATE_USER_AUTH = "UPDATE_USER_AUTH";
export const SSO_LOGIN = "SSO_LOGIN";
export const SSO_LOGIN_SUCCESS = "SSO_LOGIN_SUCCESS";
export const SSO_LOGIN_FAILURE = "SSO_LOGIN_FAILURE";
